export default {
  title: process.env.VUE_APP_TITLE,
  message: {
    login: 'Пријава',
    logout: 'Одјава'
  },
  login: {
    title: 'Пријава',
    forgottenPassword: 'Заборављена лозинка',
    loginAdAccount: 'Tрезор АД',
    loginStandardAccount: 'Пријава на сервис',
    anonymousAccess: 'Анонимни приступ'
  },
  account: {
    registerAccount: 'Подношење пријаве',
    validateAccount: 'Провера статуса пријаве',
    reportIssue: 'Пријава проблема',
    uniqueIdentificationNumber: 'ЈМБГ',
    bank: 'Банка',
    identificationNumber: 'Број личне карте поднет приликом регистрације',
    identificationNumberShort: 'Број личне карте',
    accountNumber: 'Број рачуна',
    description: 'Опис проблема (макс. 250 карактера)',
    continue: 'Напред',
    registerAccountSuccess: 'Успешно сте пријавили број рачуна',
    registerAccountTitle: 'Подношење пријаве за новчану помоћ',
    validateAccountTitle: 'Провера статуса пријаве',
    registerAccountSubTitle: 'Подношење пријаве за исплату новчане помоћи',
    registerAccountSubTitleShort: 'Подношење пријаве за исплату новчане помоћи',
    validateAccountSubTitle: 'Провера статуса пријаве за исплату новчане помоћи',
    validateAccountSubTitleShort: 'Провера статуса пријаве за исплату новчане помоћи',
    reportIssueTitle: 'Пријава корисничких проблема у вези са исплатом новчане помоћи',
    reportIssueTitleShort: 'Пријава корисничких проблема у раду са сервисом',
    validateAccountSuccess: 'Пријављени рачун за исплату новчане помоћи је валидан',
    reportIssueSubText: 'Или позивом на број Контакт центра'
  },
  organization: {
    id: 'Број захтева',
    budgetUserId: 'ЈБКЈС',
    companyNumber: 'Матични број',
    companyNumberShort: 'МБ',
    taxIdNumber: 'ПИБ',
    name: 'Назив правног лица/органа',
    address: 'Адреса седишта',
    treasuryBranch: 'Број организационе јединице',
    status: 'Статус организације',
    statuses: {
      1: 'У току',
      2: 'Одобрена',
      3: 'Отказана'
    },
    details: {
      legalEntityInfo: 'Подаци о правном лицу/органу',
      canceledUserName: 'Регистрацију отказао',
      canceledDate: 'Датум отказивања',
      cancelRegistrationPrompt: 'Да ли сте сигурни да желите да откажете регистрацију?',
      createdDate: 'Датум регистрације',
      approvedDate: 'Датум активације',
      activationHeading: 'Активација администраторског налогa',
      approveRegistration: 'Активирај налог',
      approveRegistrationMsg: 'Организација успешно активирана',
      cancelRegistration: 'Откажи налог'
    }
  },
  user: {
    username: 'Адреса електронске поште',
    password: 'Лозинка',
    confirmPassword: 'Потврди лозинку',
    email: 'И-мејл',
    firstTimeLogin: 'Пријављујем се први пут',
    passwordForgotten: 'Заборављена лозинка',
    passwordResetLinkSent: 'Линк за поновно постављање лозинке је послат на вашу адресу електронске поште',
    phoneNumber: 'Број телефона',
    mobileNumber: 'Број мобилног телефона'
  },
  dashboard: {
    text: 'Добродошли'
  },
  issue: {
    id: 'Редни број',
    phoneNumber: 'Број телефона',
    mobileNumber: 'Број мобилног телефона',
    subsidyRegisterConfirmation: 'Проверите да ли сте унели исправне податке.',
    reportIssueSuccess: 'Успешно сте пријавили проблем.',
    email: 'Електронска пошта',
    name: 'Име',
    description: 'Опис',
    uniqueIdentificationNumber: 'ЈМБГ',
    userType: 'Тип корисника',
    identificationNumber: 'Број личне карте',
    createdDate: 'Датум креирања',
    lastChangeDate: 'Датум последње измене',
    lastChangedUserId: 'Последњи изменио',
    changedComments: 'Коментар',
    comment: 'Коментар',
    status: 'Статус',
    review: 'Преглед',
    details: 'Детаљи',
    resolveComment: 'Коментар',
    unresolveComment: 'Коментар',
    denyComment: 'Коментар',
    resolve: 'Означи као решено',
    resolveTitle: 'Означи као решено',
    denyTitle: 'Означи као одбијено',
    unresolve: 'Означи као нерешено',
    unresolveTitle: 'Означи као нерешено',
    deny: 'Означи као одбијено',
    changeStatusSuccess: 'Успешно сте променили статус проблема',
    problemType: 'Тип проблема'
  },
  issueStatus: {
    1: 'У току',
    2: 'Решено',
    3: 'Нерешено',
    4: 'Одбијено'
  },
  sidebar: {
    dashboard: 'Дешборд',
    administration: 'Администрација',
    manageSystemUsers: 'Системски корисници',
    registerSystemUsers: 'Масовно креирање корисника',
    registerSystemUser: 'Креирање корисника',
    reviewUsers: 'Пријаве за исплату новчане помоћи',
    registerUserSubsidy: 'Претрага пријава за исплату новчане помоћи',
    registerUser: 'Регистрација пријаве за исплату новчане помоћи',
    updateUser: 'Претрага валидних пријава',
    reviewUser: 'Претрага свих пријава',
    reviewBeneficiary: 'Претрага деце',
    reviewBeneficiaries: 'Претрага регистра деце',
    reviewOrganizations: 'Правна лица',
    subsidy: 'Новчана помоћ',
    payments: 'Плаћања',
    generateOrders: 'Генерисање налога',
    reports: 'Извештаји',
    subsidyReport: 'Субвенције грађана',
    ministryReport: 'Дневни извештај за МФ',
    issues: 'Рекламације',
    issueReport: 'Рекламације'
  },
  reports: {
    filter: {
      from: 'Од',
      to: 'До',
      userType: 'Тип корисника',
      bank: 'Банка'
    },
    excel: 'Ексел',
    ministry: 'Министарство',
    issue: 'Рекламације-кумулативно'
  },
  contextPath: {
    administration: 'Администрација',
    organizations: 'Организације',
    users: 'Корисници',
    subsidy: 'Пријава за исплату новчане помоћи',
    systemusers: 'Системски корисници',
    partner: 'Партнери',
    user: 'Физичка лица',
    organization: 'Правна лица',
    accounts: 'Рачуни',
    reviewaccount: 'Рачуни',
    reports: 'Извештаји',
    payments: 'Плаћања',
    issue: 'Рекламације',
    details: 'Детаљи'
  },
  tabulator: {
    ajax: {
      loading: 'Учитавам', // ajax loader text
      error: 'Грешка' // ajax error text
    },
    groups: { // copy for the auto generated item count in group header
      item: 'ставка', // the singular  for item
      items: 'ставке' // the plural for items
    },
    pagination: {
      page_size: 'Редова по страни:', // label for the page size select element
      first: 'Прва', // text for the first page button
      first_title: 'Прва страна', // tooltip text for the first page button
      last: 'Последња',
      last_title: 'Последња страна',
      prev: 'Претходна',
      prev_title: 'Претходна страна',
      next: 'Следећа',
      next_title: 'Следећа страна'
    },
    headerFilters: {
      default: 'филтрирај', // default header filter placeholder text
      columns: {
        name: 'филтрирај име' // replace default header filter text for column name
      }
    },
    emptyTable: 'Нема информација',
    totalElements: 'Укупно редова: '
  },
  roles: {
    Role_Administrator: 'Администратор',
    Role_Control: 'Контрола',
    Role_Operator: 'Оператер управе за трезор',
    Role_HelpDesk: 'Корисничка подршка',
    Role_Integration: 'Интеграција',
    Role_Refresh_Token: 'Освеживање токена',
    1: 'Администратор',
    2: 'Контрола',
    3: 'Оператер управе за трезор',
    4: 'Корисничка подршка',
    5: 'Интеграција'
  },
  claims: {
    label: 'Oвлашћења',
    name: 'Назив',
    description: 'Опис',
    Claim_Admin: 'Администрација',
    Claim_Admin_Description: 'Управљање свим функционалностима на систему',
    Claim_SystemUser_Create: 'Креирање корисника',
    Claim_SystemUser_Create_Description: 'Креирање глобалног корисника на систему',
    Claim_SystemUser_Review: 'Преглед корисника',
    Claim_SystemUser_Review_Description: 'Преглед корисника на систему',
    Claim_SystemUser_Revoke: 'Опозив корисника',
    Claim_SystemUser_Revoke_Description: 'Опозив корисника од стране оператора трезора'
  },
  general: {
    phone: 'Број телефона',
    email: 'Адреса електронске поште',
    changelog: 'Информације о верзијама сервиса',
    technicalSupport: 'Пријава проблема',
    nameAndSurname: 'Име и презиме',
    personalIdentityNumber: 'ЈМБГ',
    identityNumber: 'Број идентификационе исправе',
    postalCode: 'Поштански број',
    noDataAvailable: 'Подаци нису доступни',
    userLogin: 'Кориснички налог'
  },
  bool: {
    yes: 'Да',
    no: 'Не'
  },
  status: {
    Active: 'Активан',
    Inactive: 'Неактиван',
    Revoked: 'Опозван',
    Disabled: 'Онемогућен'
  },
  form: {
    ok: 'У реду',
    cancel: 'Одустани',
    submit: 'Потврди',
    submitRequest: 'Пошаљи захтев',
    submitDocument: 'Отпреми документ',
    send: 'Пошаљи',
    close: 'Затвори',
    save: 'Сачувај',
    apply: 'Примени',
    edit: 'Измени',
    warning: 'Упозорење',
    notification: 'Обавештење',
    load: 'Учитај',
    saveToFile: 'Сачувај у фајл',
    saveToDiagnosticFile: 'Сачувај у дијагностички фајл',
    saveToClipboard: 'Сачувај у клипборд',
    capsLockOn: 'Укључен је CapsLock',
    activate: 'Активирај',
    revoke: 'Опозови',
    saveSubscription: 'Сачувај претплату',
    add: 'Унос',
    update: 'Ажурирај',
    success: 'Успешно сте извршили акцију',
    delete: 'Обриши',
    exportToCsv: 'Извоз у цсв',
    exportToJson: 'Извоз у јсон',
    notChangedForm: 'Морате променити бар једно поље'
  },
  activation: {
    title: 'Активација корисника',
    success: 'Корисник успешно активиран',
    activationSent: 'Линк за активацију корисника је послат на вашу адресу електронске поште'
  },
  reset: {
    title: 'Постављање лозинке',
    success: 'Корисничка лозинка успешно постављена'
  },
  errors: {
    someErrorsOccuredCheckListBelow: 'Дошло је до грешке. Проверите списак грешака испод',
    fileNameLength: 'Назив документа улазног фајла није исправан',
    fileSize: 'Величина документа превазилази дозвољену величину од 2МБ',
    token: {
      refreshTokenExpired: 'Обновљиви токен је истекао',
      failedToRefreshToken: 'Грешка приликом добијања приступног токена након освежавања'
    }
  },
  autocomplete: {
    completeSedarchMessage: 'Унети критеријум \'{query}\' задовоља више од {limit} резултата. Сузите критеријум или наставите претрагу на {url}',
    urlText: 'spisku KJS'
  },
  dropzone: {
    defaultMessage: 'Превуците датотеку у уоквирени део или кликните за дијалог',
    allowedFormats: 'Дозвољени фајлови типа: ',
    unsupportedFile: 'Недозвољен тип фајла!',
    tooManyFiles: 'Превукли сте више од дозвољеног броја фајлова'
  },
  systemUsers: {
    loadErrorTitle: 'Списак грешака при креирању системских корисника',
    importSystemUsersEmptyData: 'Датотека са системским корисницима није пронађена',
    importSystemUsersSuccess: 'Системски корисници успешно учитани',
    validationImport: 'Креирање није могуће док се грешке не исправе',
    revokeDate: 'Датум',
    revokeLogin: 'Променио',
    revokeComment: 'Коментар опозива',
    roles: 'Корисничке улоге',
    roleDescription: 'Опис корисничке улоге',
    success: 'Успешно сте променили информације корисника',
    statusRestore: 'Успешно сте опозвали корисника',
    statusActivate: 'Успешно сте активирали корисника'
  },
  administration: {
    reviewSystemUsers: 'Преглед системских корисника',
    userDetails: 'Детаљи корисничког налога',
    organizationDetails: 'Детаљи правног лица/органа',
    userStatus: 'Статус корисника',
    email: 'Електронска пошта',
    name: 'Име',
    administration: 'Управљање корисницима',
    localAdministration: 'Управљање локалним корисницима',
    localUserRoles: 'Корисничкa улогa',
    localUserClaims: 'Корисничка овлашћења',
    groupName: 'Назив групе',
    userGroups: 'Група корисника',
    roleName: 'Назив улоге',
    roleDescription: 'Опис',
    addNewUser: 'Нови Корисник',
    addNewGroup: 'Нова Група',
    addNewRole: 'Нова Улога',
    apply: 'Примени',
    userCreateConfirmation: 'Креирати новог локалног корисника?',
    userGroupCreateConfirmation: 'Да ли желите да креирате нову корисничку групу?',
    userRoleCreateConfirmation: 'Да ли желите да креирате нову корисничку улогу?',
    createUserSuccessful: 'Успешно сте креирали корисника',
    createRoleSuccessful: 'Успешно сте креирали корисничку улогу',
    createGroupSuccessful: 'Успешно сте креирали групу',
    profileEditPrompt: 'Да ли сте сигурни да желите да измените информације корисника?',
    permissionEditPrompt: 'Да ли сте сигурни да желите да измените овлашћења и улоге корисника?',
    revokePromptTitle: 'Да ли сте сигурни да желите да опозовете корисника?',
    revokePromptPlaceholder: 'Унесите коментар опозива',
    activatePrompt: 'Да ли сте сигурни да желите да активирате корисника?',
    userPasswordRequirement: {
      0: 'лозинка мора садржати најмање 12 карактера',
      1: 'лозинка мора садржати бројеве',
      2: 'лозинка мора садржати велика слова',
      3: 'лозинка мора садржати симболе'
    },
    changePassword: 'Промена лозинке',
    changePersonalInformation: 'Промена личних података',
    oldPassword: 'Стара лозинка',
    newPassword: 'Нова лозинка',
    confirmNewPassword: 'Потврди нову лозинку',
    password: 'Лозинка',
    confirmPassword: 'Потврди лозинку',
    confirmPasswordFail: 'Нова лозинка се не подудара са потврдом лозинке',
    passwordChanged: 'Нова лозинка успешно постављена',
    createUserPrompt: 'Да ли сте сигурни да желите да додате корисника?',
    profile: 'Профил',
    InfoNotSet: 'Нисте унели податке о кориснику',
    userInformationUpdateSuccess: 'Успешно сте изменили информације корисника.',
    userWithoutAvailableRoles: 'Корисник нема дефинисане расположиве улоге',
    roleCreated: 'Датум креирања',
    roleCreatedBy: 'Креирао',
    groupCreated: 'Датум креирања',
    groupCreatedBy: 'Групу креирао',
    groupStatus: 'Статус групе',
    importUsers: 'Масовно креирање корисника'
  },
  subsidy: {
    reviewUsers: 'Преглед пријава за исплату новчане помоћи',
    reviewUser: 'Преглед пријаве за исплату новчане помоћи',
    reviewOrganizations: 'Преглед правних лица',
    reviewOrganization: 'Преглед правног лица',
    companyNumber: 'Матични број',
    accountNumber: 'Број рачуна',
    taxIdNumber: 'ПИБ',
    companyName: 'Назив',
    companyStatus: 'Статус',
    userUniqueIdentificationNumber: 'ЈМБГ',
    userAccountNumber: 'Број рачуна',
    userIdentificationNumber: 'Број личне карте',
    holderIdentificationNumber: 'ЈМБГ родитеља',
    beneficiaries: 'Деца',
    beneficiary: 'ЈМБГ детета',
    reviewBeneficiaries: 'Претрага регистра деце',
    userFirstName: 'Име',
    userLastName: 'Презиме',
    userName: 'Име и презиме',
    paymentDate: 'Датум плаћања',
    userStatus: 'Статус',
    subsidyHeadline: '<strong style="color: #7d98b7;">МОЈА</strong> ДРЖАВА <strong style="color: #7d98b7;">МЕ</strong>ПОНОВО ПОДРЖАВА',
    subsidySubheadline: '<strong style="color: #7d98b7;">30<span>&#8364;</span></strong> ОПЕТ, А <strong style="color: #7d98b7;">20<span>&#8364;</span></strong> ОДМАХ ЗАТИМ',
    generateOrders: 'Генерисање налога за плаћање',
    rejectSubsidy: 'Одбијање пријаве',
    deleteDocument: 'Брисање документа',
    rejectSubsidyText: 'Одбијањем пријаве корисник ће бити искључен из процедуре за исплату помоћи',
    acceptSubsidy: 'Прихватање пријаве',
    acceptSubsidyText: 'Прихватањем пријаве корисник улази у процедуру за исплату помоћи',
    deleteDocumentText: 'Да ли сте сигурни да желите да обришете придружени документ',
    addBeneficiaries: 'Додај дете',
    updateBeneficiaryText: 'Прихватањем пријаве корисник улази у процедуру за исплату помоћи са ажурираном децом'
  },
  subsidyUser: {
    firstName: 'Име',
    lastName: 'Презиме',
    uniqueIdentificationNumber: 'ЈМБГ',
    fatherUniqueIdentificationNumber: 'ЈМБГ Оца',
    motherUniqueIdentificationNumber: 'ЈМБГ Мајке',
    childUniqueIdentificationNumber: 'ЈМБГ Детета',
    fatherName: 'Име оца',
    motherName: 'Име мајке',
    childName: 'Име детета',
    father: 'Отац',
    mother: 'Мајка',
    child: 'Дете',
    parentUniqueIdentificationNumber: 'ЈМБГ родитеља',
    identificationNumber: 'Број личне карте',
    accountNumber: 'Број рачуна',
    address: 'Адреса',
    city: 'Град',
    bank: 'Банка',
    createdDate: 'Датум креирања захтева',
    userType: 'Тип корисника',
    createdComments: 'Коментар регистрације',
    bankHint: 'Банка у којој ће бити отворен наменски рачун уколико је неопходно',
    subsidyAmount: 'Износ новчане помоћи',
    receivedAmount: 'Исплаћен износ',
    rejectUser: 'Искључи пријаву за исплату новчане помоћи',
    registerUser: 'Региструј пријаву за исплату новчане помоћи',
    userRegistration: 'Регистрација пријаве за исплату новчане помоћи',
    activeUserReview: 'Претрага валидне пријаве',
    userReview: 'Претрага свих пријава',
    registerUserSubsidy: 'Исплата новчане помоћи',
    beneficiaryReview: 'Претрага деце',
    beneficiariesReview: 'Претрага регистра деце',
    rejectionComments: 'Разлог искључивања пријаве из система',
    paymentAmount: 'Износ за уплату',
    beneficiaries: 'Лица обухваћена пријавом',
    sharedBeneficiaries: 'Лица дељена са придруженим лицем',
    subsidiaryUniqueIdentificationNumber: 'ЈМБГ придруженог лица',
    subsidiaryName: 'Име и презиме придруженог лица',
    subsidiaryStatus: 'Статус придруженог лица',
    dateOfBirth: 'Датум рођења',
    subsidyPaymentDate: 'Датум плаћања',
    subsidyFailed: 'Ваша пријава је одбијена услед неисправности унетих података. Молимо да поново поднесете пријаву са исправним подацима.',
    subsidyFailedBeneficiary: 'Ваша пријава није прихваћена. Уколико сматрате да остварујете право на помоћ, молимо да уложите рекламацију.',
    subsidyPending: 'Подаци о поднетој пријави су у процесу обраде. Уколико сте пријаву поднели у претходних 5 минута молимо покушајте поново након пар минута.',
    subsidyActive: 'Ваша пријава је успешно прихваћена и очекује даљу обраду.',
    subsidyWaitingAccount: ' У току је повезивање Ваших личних података са текућим рачуном у банци коју сте одабрали приликом пријаве. Уколико се утврди да немате рачун у одабраној банци, за Вас ће у истој бити отворен наменски рачун.',
    subsidyProcessed: ' У току је повезивање Ваших личних података са текућим рачуном у банци коју сте одабрали приликом пријаве. Уколико се утврди да немате рачун у одабраној банци, за Вас ће у истој бити отворен наменски рачун.',
    subsidyBlocked: 'Пријава је привремено блокирана док траје утврђивање старатељства',
    subsidyCompleted: 'Ваша новчана помоћ је уплаћена на рачун у одабраној банци',
    subsidyRejected: 'Искључени сте из система за новчану помоћ',
    subsidyError: 'Грешка приликом исплате новчане помоћи',
    subsidyFailedOperator: 'Пријава је одбијена услед неисправности унетих података.',
    subsidyPendingOperator: 'Подаци о поднетој пријави су у процесу обраде.',
    subsidyActiveOperator: 'Пријава је успешно прихваћена и очекује даљу обраду.',
    subsidyWaitingAccountOperator: 'У току је повезивање личних података са текућим рачуном у банци која је одабрана приликом пријаве.',
    subsidyAwaitingPaymentOperator: 'Пријава је повезана са текућим рачуном у банци. Очекује се слање у платни промет.',
    subsidyProcessedOperator: 'Пријава је послата на плаћање и очекује се уплата на рачун.',
    subsidyProcessedFailedOperator: 'Уплата средстава на наведени текући рачун није успела',
    subsidyCompletedOperator: 'Новчана помоћ је уплаћена на рачун у одабраној банци',
    subsidyRejectedOperator: 'Пријава је искључена из система за новчану помоћ',
    subsidyErrorOperator: 'Грешка приликом исплате новчане помоћи',
    subsidyUserStatusUpdated: 'Статус пријаве за исплату новчане помоћи је успешно измењен',
    subsidySubmit: 'Потврди плаћање',
    subsidySubmitSuccess: 'Успешно сте извршили плаћање новчане помоћи',
    subsidyUserActivationSuccess: 'Ваша пријава за новчану помоћ је евидентирана. Молимо да исправност унетих података проверите на страни <strong>Провера статуса пријаве</strong>.',
    subsidyRejectedReason: 'разлог искључивања',
    activationDate: 'Време уноса корисника',
    acceptanceDate: 'Приложени документ прихваћен',
    activationComments: 'Идентификатор интервенције техничке подршке',
    subsidyRegisterConfirmation: 'Проверите да ли сте унели исправне податке',
    subsidyActivationId: 'Запишите број пријаве како бисте остварили могућност провере стања',
    activationId: 'Идентификатор пријаве',
    activationIdHint: 'Број од осам (8) цифара који сте добили након успешно поднете пријаве',
    identificationNumberHint: 'Уколико ваша лична карта има осам (8) цифара, молимо да унесете водећу нулу',
    subsidyValidationSuccess: 'Статус пријаве за исплату новчане помоћи',
    currencyEur: 'ЕУР',
    currencyDin: 'ДИН',
    agreementHeader: 'Уредбом о формирању привременог регистра и начину уплате​​ једнократне новчане помоћи свим пунолетним држављанима Републике Србије у циљу смањивања негативних ефеката проузрокованих пандемијом болести Ковид-19 предвиђено је да привремени регистар, између осталог, садржи податке о пунолетним држављанима Републике Србије на дан ступања на снагу  ове уредбе, а на основу појединачне пријаве лица која имају активно пребивалиште на територији Републике Србије. Уредба је објављена у "Службеном гласнику РС", бр. 60/2020 од 24.4.2020.​​ године, када је и ступила на снагу и представља правни основ за обраду податка од стране Министарства финансија. Ови подаци се чувају и штите у складу са одредбама закона којим се уређује заштита података о личности.',
    agreementText: 'У складу са чланом 15. Закона о заштити података о личности („Службени гласник РС", број 87/18) саопштавњем Ваших података неопходних за доделу једнократне новчане помоћи приликом пријаве дајете свој пристанак да се Ваши подаци о личности, који обухватају ЈМБГ и број личне карте обрађују у сврху исплате једнократне новчане помоћи, истовремено потврђујући да су подаци које сте унели тачни и ажурни. Лице на које се подаци односе не сноси трошкове обраде и обавештења.',
    agreementFooter: 'Након реализације свих исплата, подаци садржани у привременом регистру ће бити обрисани',
    agreementConfirmation: 'Потврђујем сагласност',
    serviceTermination: 'Пријава за новчану помоћ је престала 15.05.2021 у 24 часа. Провера статуса пријаве као и пријава рекламација у вези са исплатом новчане помоћи је омогућена до 15.06.2021.',
    requestedOrders: 'Захтевано налога',
    availableOrders: 'Доступно налога',
    requestOrder: 'Генериши налоге',
    requestOrderError: 'Грешка приликом слања налога, проверите бројеве доступних налога у табели',
    groupOrder: 'Групни налог',
    orderNumber: 'Редни број налога',
    downloadGroupFile: 'Преузми XML фајл',
    downloadSingleFile: 'Преузми CSV фајл',
    paymentBatch: 'Послато на плаћање',
    ordersRetrieve: 'Преузми доступно',
    problemType: 'Тип проблема',
    registrationRejectionReason: 'Разлог одбијања пријаве',
    rejectionReason: {
      0: 'Неисправни лични подаци',
      1: 'Одбио МУП',
      2: 'Одбио МДУЛС',
      12: 'Одбио МУП и МДУЛС',
      3: 'Није вакцинисан',
      4: 'Корисник није означен као законски старатељ'
    }
  },
  validation: {
    nameRequired: 'Неопходно је унети име',
    userTypesRequired: 'Неопходно је унети име',
    emailRequired: 'Неопходно је унети електронску пошту',
    roleRequired: 'Неопходно је изабрати улогу',
    filterUrlRequired: 'Неопходно је унети филтер URL',
    oldPasswordNecessary: 'Неопходно је унети стару лозинку',
    newPasswordNecessary: 'Неопходно је унети стару лозинку',
    repeatedPasswordNecessary: 'Неопходно је унети стару лозинку',
    repeatedPasswordNotMatch: 'Неопходно је да се нова и поновљена лозинка подударају.',
    repeatMustMatch: 'Лозинке се не поклапају',
    oldPasswordRequired: 'Неопходно je унети стару лозинку',
    passwordRequired: 'Неопходно je унети лозинку',
    password: {
      0: 'лозинка мора бити најмање дужине 12',
      1: 'лозинка мора садржати бројеве',
      2: 'лозинка мора садржати велика слова',
      3: 'лозинка мора садржати симболе'
    },
    emailFormat: 'Е-маил није у одговарајућем формату',
    duplicateEmail: 'Е-маил је дуплиран у листи',
    userNameFormat: 'Име није у одговарајућем формату',
    userNameEmpty: 'Име није дефинисано',
    emailEmpty: 'Е-маил није дефинисан'
  },
  userStatuses: {
    1: 'Неактиван',
    2: 'Активан',
    3: 'Чека на рачун',
    4: 'У обради',
    5: 'Исплаћен',
    6: 'Одбијен',
    7: 'Грешка',
    8: 'Привремено блокиран',
    9: 'Привремено блокиран',
    101: 'Захтева документ',
    102: 'Документ достављен'
  },
  userTypes: {
    1: 'Запослено лице',
    2: 'Незапослено лице',
    3: 'Хранитељ',
    5: 'Социјална категорија',
    6: 'Остали корисници'
  },
  exportUserTypes: {
    1: 'Хранитељи',
    2: 'Корисници социјалне помоћи',
    3: 'УИКС',
    4: 'Остали',
    5: 'Кумулативно'
  },
  issueUserTypes: {
    1: 'Корисници социјалне помоћи',
    2: 'Остали'
  },
  problemTypes: {
    1: 'Није ми уплаћен новац у банци у којој примам пензију',
    2: 'На мом рачуну примамо пензије моја деца и ја, а примили смо само једну уплату',
    3: 'Не живим на територији Републике Србије али примам пензију из ове земље',
    4: 'Нисам у могућности да подигнем свој новац, да ли може неко уместо мене',
    5: 'Новац се не налази на рачуну у банци која је наведена приликом провере статуса',
    6: 'Више пута сам се пријавио са подацима из важећих докумената, а на провери статуса не испуњавам услове',
    7: 'Исправност мојих података је потврђена од стране релевантног органа, а и даље не испуњавам услов',
    8: 'Остало'
  },
  userSubsidyTypes: {
    1: 'Пензионери и примаоци социјалне помоћи',
    2: 'Остали'
  },
  systemUserStatuses: {
    1: 'Активан',
    2: 'Неактиван',
    3: 'Деактивиран'
  },
  groupStatuses: {
    1: 'Активна',
    2: 'Неактивна'
  },
  rowStatus: {
    active: 'Активан',
    inactive: 'Неактиван'
  },
  apiStatusCodes: {
    0: 'Подаци о физичким лицима су у статусу обраде, молимо покушајте поново након пар минута',
    400: 'Обрада захтева за исплату новчане помоћи није успела, молимо покушајте поново након пар минута',
    401: 'Грешка приликом ауторизације корисника',
    403: 'Немате одговарајуће корисничке привилегије',
    404: 'Није пронађена захтевана страна',
    422: 'Формат послатог захтева није исправан',
    429: 'Лимит на број упућених захтева за појединачаног корисника је достигнут. Уколико захтев подносите са радног места или преко дељене интернет адресев, молимо покушајте поново након неколико минута.',
    500: 'Подаци о физичким лицима су у статусу обраде, молимо покушајте поново након неколико минута',
    VALIDATION_ERROR: 'Формат послатог захтева није исправан',
    // Fluent
    UNIQUE_IDENTIFICATION_NUMBER: 'ЈМБГ',
    IDENTIFICATION_NUMBER: 'Број личне карте',
    USER_ACCOUNT_NUMBER: 'Број рачуна',
    USER_PAYMENT_AMOUNT: 'Износ новчане помоћи',
    FIRST_NAME: 'Име',
    LAST_NAME: 'Презиме',
    USER_REJECTION_COMMENTS: 'Коментар искључења',
    USER_ACTIVATION_COMMENTS: 'Коментар активације',
    USER_ACTIVATION_ID: 'Идентификатор пријаве',
    SUBSIDY_REPORT_FILTER: 'Филтер',
    RETRIEVE_EXPORT_USERS: 'Не постоје корисници који задовољавају задати критеријум',

    SYSTEM_USER_LOGIN: 'Адреса електронске поште',
    SYSTEM_USER_NAME: 'Корисничко име',
    SYSTEM_USER_PASSWORD: 'Лозинка',
    SYSTEM_USER_NEW_PASSWORD: 'Нова лозинка',
    SYSTEM_USER_ROLE_ID: 'Корисничка улога',
    SYSTEM_USER_ID: 'Ид системског корисника',
    SYSTEM_USER_CHANGED_COMMENTS: 'Коментар',

    ISSUE_NAME: 'Име и презиме',
    ISSUE_EMAIL: 'Електронска пошта',
    ISSUE_UNIQUE_IDENTIFICATION_NUMBER: 'ЈМБГ',
    ISSUE_USER_TYPE: 'Тип корисника',
    ISSUE_PROBLEM_TYPE: 'Тип проблема',
    ISSUE_DESCRIPTION: 'Опис',
    ISSUE_IDENTIFICATION_NUMBER: 'Број личне карте',
    ISSUE_OTHER_CONTACT: 'Други контакт',

    RETRIEVE_BENEFICIARY: 'Пријава за исплату новчане помоћи није пронађена у регистру',

    USER_TYPE: 'Неисправан формат типа корисника',
    // Subsidy
    USER_PAYMENTS_BODY_EMPTY: 'Захтев за исплату новчане помоћи не садржи податке',
    USER_ACCOUNTS_BODY_EMPTY: 'Захтев за постављање рачуна на чекање не садржи податке',
    RETRIEVE_USER: 'Пријава за исплату новчане помоћи није пронађена у регистру',
    RETRIEVE_PAGED_USERS: 'Није могуће прикупити податаке о пријавама за исплату новчане помоћи',
    RETRIEVE_ACTIVE_USERS: 'Није могуће прикупити податаке о валидним пријавама за исплату новчане помоћи',
    RETRIEVE_ANONYMOUS_USER: 'Пријава за исплату новчане помоћи није пронађена у регистру, молимо проверите унете податке',
    RETRIEVE_PENDING_ANONYMOUS_USERS: 'Грешка приликом прикупљања захтева на чекању',
    REGISTER_USER_ACCOUNTS: 'Додавање рачуна за пријаву за исплату новчане помоћи није успело',
    ACTIVATE_USER: 'Валидација пријаве за исплату новчане није успела',
    ACTIVATE_ANONYMOUS_USERS: 'Валидација пријава за исплату новчане помоћи није успела',
    RETRIEVE_USER_ACCOUNT: 'Пријављени рачун за исплату новчане помоћи није валидан',
    RETRIEVE_USERS: 'Грешка приликом прикупљања података о пријавама за исплату новчане помоћи',
    INVALID_USER_STATE: 'Пријава за исплату новчане помоћи није пронађена или није у одговарајућем статусу',
    INVALID_PROCESS_ACCOUNT_STATE: 'Рачун за исплату новчане помоћи није пронађен или није у одговарајућем статусу',
    ALREADY_ACTIVATED_USER: 'Пријава за исплату новчане помоћи са наведеним подацима је већ поднета',
    INVALID_ACTIVATION_USER_BANK: 'Банка није пронађена у регистру',
    ANONYMOUS_USER_NOT_FOUND: 'Пријава за исплату новчане помоћи није пронађена',
    ANONYMOUS_USER_PROCESSED: 'Пријава за исплату новчане помоћи није у одговарајућем статусу',
    INVALID_USER_STATUS: 'Пријава за исплату новчане помоћи није у одговарајућем статусу',
    DUPLICATE_USER_PAYMENT: 'Извршена је дупла уплата новчане помоћи',
    DUPLICATE_USER_ACCOUNT: 'Пачун за за исплату новчане помоћи је већ регистрован у систему',
    DUPLICATE_USER_ACTIVATION: 'Регистрована је дупла валидација идентичне пријаве за исплату новчане помоћи',
    INVALID_USER_PAYMENT_STATE: 'Пријава за исплату новчане помоћи није поднета',
    INVALID_USER_ACCOUNT_STATE: 'Рачун за исплату новчане помоћи није пронађен или није у одговарајућем статусу',
    INVALID_USER_ACCOUNT_REGISTER_STATE: 'Промена рачуна правног лица није регистрован',
    INVALID_USER_ACTIVATE_STATE: 'Активација правног лица није регистрована',
    ANONYMOUS_USER_ALREADY_ACTIVATED: 'Валидна пријава за исплату новчане помоћи са наведеним подацима је већ поднета',
    ANONYMOUS_USER_INVALID_DATA: 'Пријава за исплату новчане помоћи је означена као невалидна',
    PENDING_USER_STATUS: 'Није могуће променити статус пријаве за исплату новчане помоћи са статусом - у току',
    PROCESSED_USER_STATUS: 'Није могуће променити статус пријаве за исплату новчане помоћи са статусом - у процесу плаћања',
    COMPLETED_USER_STATUS: 'Није могуће променити статус пријаве за исплату новчане помоћи са статусом - плаћено',
    REJECTED_USER_STATUS: 'Није могуће променити статус пријаве за исплату новчане помоћи са статусом - одбијен',
    ERROR_USER_STATUS: 'Није могуће променити статус пријаве за исплату новчане помоћи са статусом - грешка',
    ACTIVE_USER_STATUS: 'Није могуће променити статус пријаве за исплату новчане помоћи са статусом - активан',
    WAITING_ACCOUNT_USER_STATUS: 'Није могуће променити статус пријаве за исплату новчане помоћи са статусом - чека рачун',
    UPDATE_USER_STATUS: 'Промена статуса пријаве за исплату новчане помоћи није регистрована',
    REGISTER_ANONYMOUS_USER: 'Подношење пријаве за исплату новчане помоћи није успело, молимо проверите унете податке',
    VALIDATE_ANONYMOUS_USER: 'Поднета пријава за исплату новчане помоћи није пронађена, молимо проверите унете податке',
    VALIDATE_USER: 'Поднета пријава за исплату новчане помоћи није пронађена, молимо проверите унете податке',
    ALREADY_REGISTERED_USER: 'Пријава за исплату новчане помоћи са наведеним подацима је већ регистрована у систему',
    ENDED_ANONYMOUS_USER_REGISTRATION: 'Пријава за новчану помоћ је престала',
    RETRIEVE_PRISONER_REPORT_DATA: 'Подаци достављни од стране УИКС су у обради',
    RETRIEVE_BENEFICIARY_DATA: 'Подаци о детету нису пронађени у регистру',
    INVALID_UPDATE_BENEFICIARIES_USER_STATUS: 'За корисника у статусу у процесу плаћања, чека на рачун и активан није дозвољено аљурирање деце',
    UPDATE_USER_BENEFICIARIES: 'Грешка приликом ажурирања деце',
    INVALID_REMOVE_BENEFICIARIES_USER_STATUS: 'Повраћај није дозвољен',
    INVALID_UNIQUE_IDENTIFICATION_NUMBER: 'ЈМБГ детета није валидан',
    INVALID_HOLDER_UNIQUE_IDENTIFICATION_NUMBER: 'ЈМБГ корисника помоћи није валидан',
    DUPLICATE_UNIQUE_IDENTIFICATION_NUMBER: 'ЈМБГ деце мора бити јединствен',
    INVALID_REGISTER_BENEFICIARIES_USER: 'Није могуће додати децу у регистар ако је корисник има валидну пријаву. За валидне пријаве ажурирање деце се ради на детаљима корисника',
    EMPTY_REGISTER_BENEFICIARIES: 'Нема деце за унос. Дете је вероватно већ унето за корисника',
    EMPTY_BENEFICIARIES: 'Деца морају бити унесена',
    RETRIEVE_BENEFICIARIES: 'Није могуће прикупити податке о регистру деце',
    INVALID_USER_BENEFICIARIES_AGE: 'Узраст деце није валидан',

    DB_PAGED_USERS: 'Непозната грешка приликом прикупљања података о физичким лицима',
    DB_ACTIVE_USERS: 'Непозната грешка приликом прикупљања података о активним физичким лицима',
    DB_PENDING_ANONYMOUS_USERS: 'Непозната грешка приликом прикупљања података о пријавама на чекању',
    DB_REGISTER_USER_ACCOUNTS: 'Непозната грешка приликом регистрације рачуна пријаве за исплату новчане помоћи',
    DB_REGISTER_USER: 'Непозната грешка приликом регистрације пријаве за исплату новчане помоћи',
    DB_RETRIEVE_USER_ACCOUNT: 'Непозната грешка приликом прикупљања података о рачуну пријаве за исплату новчане помоћи',
    DB_REGISTER_USER_PAYMENTS: 'Непозната грешка приликом исплате новчане помоћи',
    DB_PROCESS_USER_PAYMENTS: 'Непозната грешка приликом промене статуса физичких лица у процес плаћања',
    DB_PROCESS_USER_ACCOUNTS: 'Непозната грешка приликом промене статуса рачуна физичких лица у - чека рачун',
    DB_RETRIEVE_USERS: 'Непозната грешка приликом прикупљања података о пријави за исплату новчане помоћи',
    DB_RETRIEVE_ANONYMOUS_USERS: 'Непозната грешка приликом прикупљања података о пријави за исплату новчане помоћи',
    DB_VALIDATE_USER_PAYMENTS: 'Непозната грешка приликом валидације плаћања новчане помоћи',
    DB_RETRIEVE_USER: 'Непозната грешка приликом прикупљања података о пријави за исплату новчане помоћи',
    DB_RETRIEVE_ANONYMOUS_USER: 'Није могуће пронаћи поднету пријаву, молимо проверите унете податке',
    DB_UPDATE_USER_STATUS: 'Непозната грешка приликом промене статуса пријаве за исплату новчане помоћи',
    DB_REJECT_USER: 'Непозната грешка приликом одбијања пријаве за исплату новчане помоћи',
    DB_ACTIVATE_USER: 'Непозната грешка приликом валидације пријаве за исплату новчане помоћи',
    DB_ACTIVATE_ANONYMOUS_USER: 'Непозната грешка приликом активирања пријаве за исплату новчане помоћи',
    DB_REGISTER_ANONYMOUS_USER: 'Дошло је до грешке. Подношење пријаве није успело, молимо проверите унете податке',
    DB_VALIDATE_ANONYMOUS_USER: 'Поднета пријава за исплату новчане помоћи пронађена, молимо проверите унете податке',
    DB_VALIDATE_USER: 'Поднета пријава за исплату новчане помоћи није пронађена, молимо проверите унете податке',
    DB_ADD_ISSUE: 'Непозната грешка приликом подношења рекламације',
    DB_UPDATE_USER_BENEFICIARIES: 'Непозната грешка приликом ажурирања деце',
    DB_REGISTER_USER_BENEFICIARIES: 'Непозната грешка приликом додавања деце у регистар',
    DB_RETRIEVE_BENEFICIARIES: 'Непозната грешка приликом прикупљања података о регистру деце',

    TRAN_REGISTER_ANONYMOUS_USER: 'Дошло је до грешке. Подношење пријаве није успело, молимо проверите унете податке',
    TRAN_REGISTER_DUPLICATE_ANONYMOUS_USER: 'Пријава за исплату новчане помоћи лица са наведеним подацима је већ поднета',

    // Issue

    TRAN_USER_ALREADY_HAS_PENDING_ISSUE: 'Није могуће унети нову рекламацију док се постојећа не реши.',
    ENDED_REPORTING_ISSUE: 'Подношење рекламација је престало',

    // Administration
    SYSTEM_USER_NOT_FOUND: 'Системски корисник није пронађен',
    PAGED_SYSTEM_USERS: 'Грешка приликом прикупљања података о системским корисницима',
    INVALID_PASSWORD: 'Кориснички креденцијали нису исправни',
    TOKEN_REVOKED: 'Токен системског корисника није валидан или је деактивиран',
    REFRESH_TOKEN: 'Помоћни токен за системског корисника није пронађен',
    PASSWORD_ERROR: 'Грешка приликом промене лозинке',
    INVALID_CLAIMS: 'Није могуће прикупити информације о корисничким привилегијама',
    SYSTEM_USER_INACTIVE: 'Системски корисник је означен као неактиван',
    SYSTEM_USER_DISABLED: 'Системски корисник је означен као деактивиран',
    CREATE_SYSTEM_USER: 'Грешка приликом креирања системског корисника. Подаци нису валидни',
    UPDATE_SYSTEM_USER: 'Грешка приликом измене системског корисника. Подаци нису валидни',
    RETRIEVE_ROLES: 'Грешка приликом прикупљања података о корисничким улогама',
    ACTIVATION_TOKEN_INVALID: 'Активациони токен није валидан или је празан',
    RETRIEVE_REGISTRATION: 'Kориснички налог није пронађен',
    SYSTEM_USER_ALREADY_ACTIVATED: 'Системски корисник је већ активан',
    SYSTEM_USER_DEACTIVATED: 'Системски корисник је деактивиран',
    ACTIVATION_MAIL_CLIENT: 'Грешка приликом слања активационог емаил-а',
    PASSWORD_RESET_MAIL_CLIENT: 'Грешка приликом слања емаил-а за промену лозинке',
    RETRIEVE_ACTIVATION_TOKEN: 'Грешка приликом прикупљања валидног активационог токена',
    RETRIEVE_ACTIVE_SYSTEM_USER: 'Грешка приликом прикупљања активног корисничког налога',
    ACTIVATE_SYSTEM_USER: 'Грешка приликом активирања корисникичког налога',
    ERR_FAILED_TO_SELF_ASSIGN_STATUS: 'Промена својих података није дозвољена',
    ERR_FORBIDDEN_SYSTEM_USER_STATUS_UPDATE: 'Покушај промене недозвољеног статуса системског корисника',
    ERR_FAILED_TO_PERSIST_SYSTEM_USER_STATUS: 'Грешка приликом промене статуса системског корисника',
    PASSWORD_LENGTH: 'Лозинка мора бити најмање дужине 12',
    PASSWORD_NUMBERS: 'Лозинка мора садржати бројеве',
    PASSWORD_UPPERCASE: 'Лозинка мора садржати велика слова',
    PASSWORD_SYMBOLS: 'Лозинка мора садржати симболе',
    CHANGE_ROLE_NOT_VALID: 'Промена системске улоге није дозвољена',
    SYSTEM_USER_LOGIN_DUPLICATE: 'Пронађене дупле адресе електронске поште',
    SYSTEM_USER_LIMIT: 'Прекорачен број дозвољених системских корисника',

    DB_ACCESS_TOKEN: 'Непозната грешка приликом креирања приступног токен',
    DB_REFRESH_TOKEN: 'Непозната грешка приликом генерисања помоћног токена',
    DB_RETRIEVE_SYSTEM_USERS: 'Непозната грешка приликом добијања информација о системским корисницима',
    DB_CREATE_SYSTEM_USER: 'Непозната грешка приликом креирања системских корисника',
    DB_CLAIMS_RETRIEVE: 'Непозната грешка приликом добијања информација о корисничкин привелегијама',
    DB_SYSTEM_USER_RETRIEVE: 'Непозната грешка приликом добијања информација о системском кориснику',
    DB_VALIDATE_SYSTEM_USER: 'Непозната грешка приликом валидације системског корисника',
    DB_ACTIVATION_TOKEN_CREATE: 'Непозната грешка приликом креирања активационог токена',
    DB_ACTIVATE_REGISTERED_SYSTEM_USER: 'Непозната грешка приликом активације регистрације системског корисника',
    DB_VALIDATE_ACTIVATION_TOKEN: 'Непозната грешка приликом валидације активационог корисника',
    DB_PASSWORD_CHANGE: 'Непозната грешка приликом промене лозинке системског корисника',
    DB_UPDATE_SYSTEM_USER: 'Непозната грешка приликом измене системског корисника',

    TRAN_CREATE_SYSTEM_USER_LOGIN_EXISTS: 'Кориснички налог заузет',
    TRAN_CREATE_SYSTEM_USER: 'Непозната грешка приликом креирања системских корисника',
    TRAN_UNKNOWN: 'Непозната грешка прикиком извршавања команди над базом података'
  }
}
